<template>
  <div class="animated fadeIn">
    <survey :survey="survey" v-if="showSurvey"></survey>
    <div v-if="!showSurvey"><p>Loading Survey</p></div>
  </div>
</template>

<script>

import * as Survey from 'survey-vue';
import { tokenMixin } from '@/mixins/tokenMixin';

var surveyJSON = {pages: [{name: 'page1', elements: [{type: 'text', name: 'question1'}]}]}
var survey = new Survey.Model(surveyJSON);
var thisVue;
Survey.showProgressBar = false;
Survey.showTitle = false;

//Survey.Survey.cssType = 'bootstrap';
//Survey.defaultBootstrapCss.navigationButton = 'btn btn-primary';
//survey.showProgressBar = 'top';

Survey.StylesManager.applyTheme('bootstrap');

var myCss = {
  row: {'background-color': 'red'}, 'navigationButton': 'button btn-lg'};

Survey.css = myCss;

export default {
  name: 'surveys',
  mixins: [tokenMixin],
  data () {
    return {
      survey: survey,
      showSurvey: false
    }
  },
  methods: {
    saveResults (sender, options) {
      var resultsdata = {
        'userSurveyId': this.userSurveyId,
        'data': sender.data
      }
      console.log(resultsdata)
      this.axios.put(process.env.VUE_APP_API_BASE + 'survey/results/submit', resultsdata, this.buildTokenHeader())
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  mounted: function () {
    //from the mixin
    if (this.checkForToken())
    {
      var sId = '8C04B712-9C20-45B1-A4FF-5C2F6EFFC557'
      if(this.$route.params.id)
      {
        sId = this.$route.params.id;
      }
      //console.log(sId)
      //8C04B712-9C20-45B1-A4FF-5C2F6EFFC557
      this.axios.get(process.env.VUE_APP_API_BASE + 'survey/get/' + sId, this.buildTokenHeader()).then(response => {
        return response
      })
      .then(res => {
        if (res.status === 200)
        {
          this.showSurvey = true;
          var tmpJSON = {pages: [{name: 'page1', elements: [{type: 'text', name: 'question1'}]}]}
          //console.log(tmpJSON);
          this.survey = new Survey.Model(res.data.surveyJSON);
          this.survey.showTitle = false;
          this.userSurveyId = res.data.userSurveyId;
          console.log(res.data)
          thisVue = this;
          this.survey.onComplete.add(function (sender, options) {
            thisVue.saveResults(sender, options);
          });
        }
      })
      .catch(error => {
        console.log(error)
      });
    }
  }
}
</script>

<!--<style scope>
.radio > label > input {
  position: static;
  margin: 0;
  padding: 0;
  opacity: 100;
  z-index: -1;
  box-sizing: border-box;
}
</style>-->
